import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  playlistDetails: {
    total_duration: 0,
  },
  playlistFetchingLoading: false
};

const playlistSlice = createSlice({
  name: "playlist",
  initialState,
  reducers: {
    setPlaylistDetails(state, action) {
      state.playlistDetails = action.payload;
    },
    setPlaylistFetchingLoading(state, action) {
      state.playlistFetchingLoading = action.payload;
    },
  },
});

export const { setPlaylistDetails, setPlaylistFetchingLoading } = playlistSlice.actions;

export default playlistSlice.reducer;
